import { useQuery } from '@tanstack/react-query';
import {
  COMMUNITY_TEMPLATE_BATCH_LIKE_STATUS_KEY,
  COMMUNITY_TEMPLATE_LIKE_STATUS_KEY,
} from '../../contracts';
import { getBatchLikeStatus, getLikeStatus } from '../api/templates';

/** `isAuthenticated` is the app's `state.auth.token` read, composed app-side (cohort-C). */
export function useQueryCommunityTemplateLikeStatus(
  templateId: string,
  isAuthenticated = true
) {
  return useQuery({
    queryKey: [COMMUNITY_TEMPLATE_LIKE_STATUS_KEY, templateId],
    queryFn: async () => {
      const { data } = await getLikeStatus(templateId);
      return data;
    },
    enabled: isAuthenticated && !!templateId,
  });
}

export function useQueryCommunityTemplateBatchLikeStatus(
  templateIds: string[],
  isAuthenticated = true
) {
  return useQuery({
    queryKey: [COMMUNITY_TEMPLATE_BATCH_LIKE_STATUS_KEY, templateIds],
    queryFn: async () => {
      if (templateIds.length === 0) {
        return { statuses: {} };
      }
      const { data } = await getBatchLikeStatus(templateIds);
      return data;
    },
    enabled: isAuthenticated && templateIds.length > 0,
  });
}
